import Storage from '../services/Storage';

const initialState = {
  loading:false,
};

export function savePublicContext(state = initialState, action) {
  switch (action.type) {
    case 'SAVE.PUBLIC_CONTEXT.SUCCESS':
      const context = Storage.getSessionItem('context') || {};
      context.publicContext = {
        ...context.publicContext,
        ...action.params
      };
      Storage.setSessionItem('context', context);
      return {
        ...state,
        ...action.params,
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/publicContext.js